import React from 'react';
import PropTypes from 'prop-types';

import {TextField} from 'views/components';

const fieldSx = {
  '& .MuiInputBase-root': {
    borderRadius: '7px',
    fontSize: '12px',
    backgroundColor: '#FFFFFF',
  },
  '& .MuiInputBase-input': {
    fontSize: '12px',
    lineHeight: '18px',
  },
  '& .MuiInputLabel-root': {
    fontSize: '12px',
  },
};

const DraftTextField = (props) => {
  const {
    label,
    multiline = false,
    onChange,
    value,
  } = props;

  return (
    <TextField
      fullWidth
      label={label}
      minRows={multiline ? 3 : undefined}
      multiline={multiline}
      onChange={onChange}
      size='small'
      value={value || ''}
      sx={fieldSx}
    />
  );
};

DraftTextField.propTypes = {
  label: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const JsonTextField = (props) => {
  const {
    label,
    onChange,
    value,
  } = props;

  return (
    <TextField
      fullWidth
      label={label}
      minRows={5}
      multiline
      onChange={onChange}
      size='small'
      value={value || ''}
      sx={{
        ...fieldSx,
        '& .MuiInputBase-input': {
          fontFamily: 'monospace',
          fontSize: '11px',
          lineHeight: '17px',
        },
      }}
    />
  );
};

JsonTextField.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export {
  DraftTextField,
  JsonTextField,
  fieldSx,
};
